import { createPopulatedItemClientFactory, createPopulatedModifierGroupClientFactory } from './factoryCreator';
import { itemPopulationLevelNone, modifierGroupPopulationLevelNone } from '../utils/consts';
export const PopulatedItemClientFactory = _ref => {
  let {
    httpClient,
    populationLevel = itemPopulationLevelNone
  } = _ref;
  return createPopulatedItemClientFactory({
    httpClient,
    populationLevel
  });
};
export const PopulatedModifierGroupClientFactory = _ref2 => {
  let {
    httpClient,
    populationLevel = modifierGroupPopulationLevelNone
  } = _ref2;
  return createPopulatedModifierGroupClientFactory({
    httpClient,
    populationLevel
  });
};
//# sourceMappingURL=web.js.map